import { IRoleData, IRole } from "./role.types";
import { Role } from "./role";

export const mockRolesData = (): IRoleData[] => [
  {
    id: 1,
    code: "ROL_CASH_MYPROSEGURAPP_ADMINISTRATION",
    externalCode: "",
    module: "MY PROSEGUR CASH",
  },
  {
    id: 2,
    code: "ROL_CASH_MYPROSEGURAPP_USER-MANAGEMENT",
    externalCode: "",
    module: "MY PROSEGUR CASH",
  },
  {
    id: 3,
    code: "ROL_CASH_MYPROSEGURAPP_DEPOSIT",
    externalCode: "",
    module: "SMART CASH",
  },
  {
    id: 4,
    code: "ROL_CASH_MYPROSEGURAPP_ISSUES",
    externalCode: "",
    module: "SMART CASH",
  },
  {
    id: 5,
    code: "ROL_CASH_MYPROSEGURAPP_BALANCES",
    externalCode: "",
    module: "SMART CASH",
  },
  {
    id: 6,
    code: "ROL_CASH_MYPROSEGURAPP_TRANSACTIONS",
    externalCode: "",
    module: "SMART CASH",
  },
  {
    id: 7,
    code: "ROL_CASH_MYPROSEGURAPP_ACCREDITATIONS",
    externalCode: "",
    module: "SMART CASH",
  },
  {
    id: 8,
    code: "ROL_CASH_MYPROSEGURAPP_PICKUP",
    externalCode: "PEDIDO_COLECTA",
    module: "SOL CUSTOMER",
  },
  {
    id: 9,
    code: "ROL_CASH_MYPROSEGURAPP_PICKUP-EXCHANGE",
    externalCode: "PEDIDO_COLECTA_CAMBIO",
    module: "SOL CUSTOMER",
  },
  {
    id: 10,
    code: "ROL_CASH_MYPROSEGURAPP_DELIVERY",
    externalCode: "PEDIDO_ENTREGA",
    module: "SOL CUSTOMER",
  },
  {
    id: 11,
    code: "ROL_CASH_MYPROSEGURAPP_DELIVERY-EXCHANGE",
    externalCode: "PEDIDO_ENTREGA_CAMBIO",
    module: "SOL CUSTOMER",
  },
  {
    id: 12,
    code: "ROL_CASH_MYPROSEGURAPP_ASSISTANCE-SERVICE",
    externalCode: "PEDIDO_ASISTENCIA",
    module: "SOL CUSTOMER",
  },
  {
    id: 13,
    code: "ROL_CASH_MYPROSEGURAPP_SUPPLY-MATERIAL-SERVICE",
    externalCode: "PEDIDO_MATERIAL_OPERATIVO",
    module: "SOL CUSTOMER",
  },
  {
    id: 14,
    code: "ROL_CASH_MYPROSEGURAPP_EMPLOYEE",
    externalCode: "CONSULTA_FOTO_Y_FIRMA",
    module: "SOL CUSTOMER",
  },
];

export const mockRoles = (data: IRoleData[] = mockRolesData()): IRole[] =>
  data.map((item) => new Role(item));
